/**
 * Safer modal backdrop dismiss — avoids accidental closes when native
 * <select> dropdowns or drags release outside the panel.
 */
export function onBackdropMouseDown(e, onClose) {
  if (e.target === e.currentTarget) onClose();
}

export function onModalPanelMouseDown(e) {
  e.stopPropagation();
}
